import React, { ReactNode, useContext, useState } from 'react';
import { Container, Container2, ContainerBox, LayerContainerMobile, Search } from './styles';
import { Indicadores, RankingContext } from '@/context/ranking';
import { SwitchToggle } from '../../atoms/SelectorArea/SwitchToggle';
import Image from 'next/legacy/image';
import { LupaSearchGray } from '../IndicatorSynthesis/styles';
import { MapContext } from '@/context/map';

interface LayerMobileProps {
  name: string
  children: ReactNode
}
export const LayerMobile: React.FC<LayerMobileProps> = ({ name, children }) => {

  return <LayerContainerMobile>
    <Image width={50} height={50} src={Indicadores[name].img} />
    {children}
  </LayerContainerMobile>

}
export const SelectorAreaMobile: React.FC = () => {
  const [cntGneral, setCntGneral] = useState(true)
  const [cntCapHum, setCapHum] = useState(false)
  const [cntDesEco, setDesEco] = useState(false)
  const [cntDesSoci, setDesSoci] = useState(false)
  const [cntCondVida, setCondVida] = useState(false)
  const [cntEduca, setEduca] = useState(false)
  const [cntInfra, setInfra] = useState(false)
  const [cntInsti, setInsti] = useState(false)
  const [cntJuventude, setJuventude] = useState(false)
  const [cntSaude, setSaude] = useState(false)
  const [cntSeg, setSeg] = useState(false)

  const { setResearchArea, researchArea } = useContext(RankingContext)
  const { setTooltipState} = useContext(MapContext)
  
  return (
    <Container>
      <Container2>
        <h4>Posição das 27 Unidades Federativas no Índice dos Desafios da Gestão Estadual</h4>
        {/* <small>Como interpretar a visualização?</small> */}
        <ContainerBox>
          <div className='flex'>
            <SwitchToggle color="#003886" onChange={() => {
              setDesEco(false)
              setCondVida(false)
              setCapHum(false)
              setCntGneral(true)
              setDesSoci(false)
              setEduca(false)
              setInfra(false)
              setInsti(false)
              setJuventude(false)
              setSaude(false)
              setSeg(false)
              setResearchArea("Geral")
            }} isCheck={cntGneral} actionElse={() => {
              setResearchArea("Geral")
            }} />
            <p>Ranking Geral</p>
          </div>
          <div className='wrrap'>
          <LayerMobile name='capital_humano'>
            <SwitchToggle color={Indicadores['capital_humano'].color} onChange={() => {
              setCapHum(true)
              setCntGneral(false)
              setDesEco(false)
              setDesSoci(false)
              setCondVida(false)
              setEduca(false)
              setInfra(false)
              setInsti(false)
              setJuventude(false)
              setSaude(false)
              setSeg(false)
              setResearchArea("capital_humano")
            }} isCheck={cntCapHum} actionElse={() => {
              setCntGneral(true)
              setCapHum(false)
              setResearchArea("Geral")
            }} />
          </LayerMobile>
          <LayerMobile name='condicoes_de_vida'>
            <SwitchToggle color={Indicadores['condicoes_de_vida'].color} onChange={() => {
              setCondVida(true)
              setCapHum(false)
              setCntGneral(false)
              setDesEco(false)
              setDesSoci(false)
              setEduca(false)
              setInfra(false)
              setInsti(false)
              setJuventude(false)
              setSaude(false)
              setSeg(false)
              setResearchArea("condicoes_de_vida")
            }} isCheck={cntCondVida} actionElse={() => {
              setCntGneral(true)
              setCondVida(false)
              setResearchArea("Geral")
            }} />
          </LayerMobile>
          <LayerMobile name='desenvolvimento_economico'>
            <SwitchToggle color={Indicadores['desenvolvimento_economico'].color} onChange={() => {
              setDesEco(true)
              setCondVida(false)
              setCapHum(false)
              setCntGneral(false)
              setDesSoci(false)
              setEduca(false)
              setInfra(false)
              setInsti(false)
              setJuventude(false)
              setSaude(false)
              setSeg(false)
              setResearchArea("desenvolvimento_economico")
            }} isCheck={cntDesEco} actionElse={() => {
              setCntGneral(true)
              setDesEco(false)
              setResearchArea("Geral")
            }} />
          </LayerMobile>
          <LayerMobile name='desenvolvimento_social'>
            <SwitchToggle color={Indicadores['desenvolvimento_social'].color} onChange={() => {
              setDesSoci(true)
              setDesEco(false)
              setCondVida(false)
              setCapHum(false)
              setCntGneral(false)
              setEduca(false)
              setInfra(false)
              setInsti(false)
              setJuventude(false)
              setSaude(false)
              setSeg(false)
              setResearchArea("desenvolvimento_social")
            }} isCheck={cntDesSoci} actionElse={() => {
              setCntGneral(true)
              setDesSoci(false)
              setResearchArea("Geral")
            }} />
          </LayerMobile>
          <LayerMobile name='educacao'>
            <SwitchToggle color={Indicadores['educacao'].color} onChange={() => {
              setEduca(true)
              setDesSoci(false)
              setDesEco(false)
              setCondVida(false)
              setCapHum(false)
              setCntGneral(false)
              setInfra(false)
              setInsti(false)
              setJuventude(false)
              setSaude(false)
              setSeg(false)
              setResearchArea("educacao")
            }} isCheck={cntEduca} actionElse={() => {
              setCntGneral(true)
              setEduca(false)
              setResearchArea("Geral")
            }} />
          </LayerMobile>
          <LayerMobile name='infraestrutura'>
            <SwitchToggle color={Indicadores['infraestrutura'].color} onChange={() => {
              setInfra(true)
              setEduca(false)
              setDesSoci(false)
              setDesEco(false)
              setCondVida(false)
              setCapHum(false)
              setCntGneral(false)
              setInsti(false)
              setJuventude(false)
              setSaude(false)
              setSeg(false)
              setResearchArea("infraestrutura")
            }} isCheck={cntInfra} actionElse={() => {
              setCntGneral(true)
              setInfra(false)
              setResearchArea("Geral")
            }} />
          </LayerMobile>
          <LayerMobile name='institucional'>
            <SwitchToggle color={Indicadores['institucional'].color} onChange={() => {
              setInsti(true)
              setInfra(false)
              setEduca(false)
              setDesSoci(false)
              setDesEco(false)
              setCondVida(false)
              setCapHum(false)
              setCntGneral(false)
              setJuventude(false)
              setSaude(false)
              setSeg(false)
              setResearchArea("institucional")
            }} isCheck={cntInsti} actionElse={() => {
              setCntGneral(true)
              setInsti(false)
              setResearchArea("Geral")
            }} />
          </LayerMobile>
          <LayerMobile name='juventude'>
            <SwitchToggle color={Indicadores['juventude'].color} onChange={() => {
              setJuventude(true)
              setInsti(false)
              setInfra(false)
              setEduca(false)
              setDesSoci(false)
              setDesEco(false)
              setCondVida(false)
              setCapHum(false)
              setCntGneral(false)
              setSaude(false)
              setSeg(false)
              setResearchArea("juventude")
            }} isCheck={cntJuventude} actionElse={() => {
              setCntGneral(true)
              setJuventude(false)
              setResearchArea("Geral")
            }} />
          </LayerMobile>
          <LayerMobile name='saude'>
            <SwitchToggle color={Indicadores['saude'].color} onChange={() => {
              setSaude(true)
              setJuventude(false)
              setInsti(false)
              setInfra(false)
              setEduca(false)
              setDesSoci(false)
              setDesEco(false)
              setCondVida(false)
              setCapHum(false)
              setCntGneral(false)
              setSeg(false)
              setResearchArea("saude")
            }} isCheck={cntSaude} actionElse={() => {
              setCntGneral(true)
              setSaude(false)
              setResearchArea("Geral")
            }} />
          </LayerMobile>
          <LayerMobile name='seguranca'>
            <SwitchToggle color={Indicadores['seguranca'].color} onChange={() => {
              setSeg(true)
              setSaude(false)
              setJuventude(false)
              setInsti(false)
              setInfra(false)
              setEduca(false)
              setDesSoci(false)
              setDesEco(false)
              setCondVida(false)
              setCapHum(false)
              setCntGneral(false)
              setResearchArea("seguranca")
            }} isCheck={cntSeg} actionElse={() => {
              setCntGneral(true)
              setSeg(false)
              setResearchArea("Geral")
            }} />
          </LayerMobile>
          </div>
          <Search>
          <LupaSearchGray />
          <p>{Indicadores[researchArea]?.label_complete}</p>
        </Search>
        </ContainerBox>
      </Container2>
    </Container>
  )
};
